/**
 * Service for providing utility functions shared across other services
 */
export class UtilityService {
  constructor(annotationDataService) {
    this.dataService = annotationDataService;
  }

  /**
   * Check if a position is valid (not earlier than any existing position)
   */
  isValidPosition(items, position, currentIndex = -1) {
    for (let i = 0; i < items.length; i++) {
      // Skip the current item when updating
      if (i === currentIndex) continue;
      
      const item = items[i];
      
      // Check if the new position is earlier than this item
      if (
        // Earlier bar
        position.bar < item.position.bar ||
        // Same bar, earlier beat
        (position.bar === item.position.bar && position.beat < item.position.beat) ||
        // Same bar and beat, earlier subdivision
        (position.bar === item.position.bar && 
         position.beat === item.position.beat && 
         position.subdivision < item.position.subdivision)
      ) {
        return false;
      }
    }
    
    return true;
  }

  /**
   * Helper method to get Chinese name for common instruments
   */
  getChineseNameForInstrument(instrument) {
    const mapping = {
      'Piano': '钢琴',
      'Keyboard': '键盘',
      'Guitar': '吉他',
      'Bass': '贝斯',
      'Drums': '鼓',
      'Violin': '小提琴',
      'Viola': '中提琴',
      'Cello': '大提琴',
      'Flute': '长笛',
      'Clarinet': '单簧管',
      'Saxophone': '萨克斯',
      'Trumpet': '小号',
      'Trombone': '长号',
      'Organ': '风琴',
      'Synthesizer': '合成器',
      'Voice': '人声'
    };
    
    return mapping[instrument] || instrument;
  }
} 